<template>
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 10.8333V10C8 8.62167 9.12167 7.5 10.5 7.5H11.3333V4.7225C11.3333 4.41583 11.0842 4.16667 10.7775 4.16667H5.2225C4.91583 4.16667 4.66667 4.41583 4.66667 4.7225V10.2775C4.66667 10.5842 4.91583 10.8333 5.2225 10.8333H8ZM8 12.5H5.2225C3.99667 12.5 3 11.5033 3 10.2775V4.7225C3 3.49667 3.99667 2.5 5.2225 2.5H10.7775C12.0033 2.5 13 3.49667 13 4.7225V7.5H15.5C16.8783 7.5 18 8.62167 18 10V15C18 16.3783 16.8783 17.5 15.5 17.5H10.5C9.12167 17.5 8 16.3783 8 15V12.5ZM9.66667 10C9.66667 9.54083 10.0408 9.16667 10.5 9.16667H15.5C15.96 9.16667 16.3333 9.54083 16.3333 10V15C16.3333 15.4592 15.96 15.8333 15.5 15.8333H10.5C10.0408 15.8333 9.66667 15.4592 9.66667 15V10Z"
      fill="white"
      fill-opacity="0.6"
    />
  </svg>
</template>
<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({})
</script>
